import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from '../../components/language-switcher'

export default function SetupPasswordPage() {
  const { t } = useTranslation()
  return (
    <div
      className='relative flex min-h-screen items-center justify-center overflow-hidden px-4 py-10 text-[#12304a]'
      style={{
        background:
          'radial-gradient(circle at top left, rgba(125, 211, 252, 0.22), transparent 30%), radial-gradient(circle at 85% 12%, rgba(96, 165, 250, 0.16), transparent 24%), linear-gradient(180deg, #ffffff 0%, #f4faff 38%, #eaf6ff 100%)',
      }}
    >
      <LanguageSwitcher variant='auth' className='fixed absolute top-4 right-4 z-20' />

      {/* Subtle grid like the landing page */}
      <div
        className='pointer-events-none fixed inset-0'
        style={{
          backgroundImage:
            'linear-gradient(rgba(186, 230, 253, 0.32) 1px, transparent 1px), linear-gradient(90deg, rgba(186, 230, 253, 0.32) 1px, transparent 1px)',
          backgroundSize: '44px 44px',
          maskImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.35), transparent 88%)',
          WebkitMaskImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.35), transparent 88%)',
        }}
      />

      {/* Soft blue glow */}
      <div className='pointer-events-none absolute -right-24 top-20 h-[460px] w-[min(48vw,580px)] rounded-full bg-gradient-to-br from-sky-300/25 to-blue-300/20 blur-3xl' />
      <div className='pointer-events-none absolute -bottom-28 -left-20 h-80 w-80 rounded-full bg-sky-200/30 blur-3xl' />

      {/* Card */}
      <div className='relative z-10 w-full max-w-md animate-slide-up'>
        <div className='rounded-[2rem] border border-sky-200/80 bg-white/90 p-8 shadow-[0_16px_50px_rgba(56,189,248,0.10)] backdrop-blur-2xl transition-all duration-300 hover:-translate-y-1 hover:border-sky-300 hover:shadow-[0_20px_56px_rgba(14,165,233,0.14)]'>
          <div className='text-center mb-8'>
            <div className='mb-5 inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-200 to-blue-200 shadow-[0_14px_32px_rgba(56,189,248,0.18)]'>
              <svg
                className='h-8 w-8 text-sky-600'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
                />
              </svg>
            </div>
            <h1 className='mb-2 text-3xl font-bold tracking-tight text-slate-950'>
              {t('auth.setupPasswordTitle')}
            </h1>
            <p className='text-sm text-slate-600'>{t('auth.setupPasswordHint')}</p>
          </div>

          <Link
            to='/login'
            className='w-full rounded-2xl bg-gradient-to-r from-sky-400 to-blue-400 px-6 py-3.5 font-semibold !text-white shadow-[0_14px_32px_rgba(56,189,248,0.24)] transition-all duration-200 hover:-translate-y-0.5 hover:brightness-[1.02] hover:shadow-[0_20px_42px_rgba(56,189,248,0.28)] focus:outline-none focus:ring-4 focus:ring-sky-200/70 block text-center'
          >
            {t('auth.backToLogin')}
          </Link>
        </div>
      </div>

      {/* Custom CSS for animations */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(24px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-slide-up {
          animation: slide-up 0.55s ease-out;
        }
        `,
        }}
      />
    </div>
  )
}
